import React, { useState } from "react";
import { Card, Collapse } from "react-bootstrap";

/**
 * Shared collapsible card used across the Integration wizard — the
 * Authentication/Connection config form's secondary field groups
 * (IntegrationConfigForm) and the Before You Begin tab's Execution History
 * section (IntegrationBeforeYouBegin) both need the exact same
 * header-toggle-chevron-body shape, so it lives here once instead of twice.
 */
const IntegrationCollapsible = ({ title, defaultOpen, bodyClassName, children }) => {
    const [open, setOpen] = useState(!!defaultOpen);
    return (
        <Card className="mb-3 border">
            <Card.Header
                onClick={() => setOpen((o) => !o)}
                className="collapsible-header d-flex align-items-center justify-content-between py-2 px-3"
            >
                <span className="fw-semibold small text-uppercase text-muted">{title}</span>
                <i className={`fa fa-chevron-${open ? "up" : "down"} text-muted font-size-11px`} />
            </Card.Header>
            <Collapse in={open}>
                <div>
                    <Card.Body className={bodyClassName}>{children}</Card.Body>
                </div>
            </Collapse>
        </Card>
    );
};

export default IntegrationCollapsible;
